import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Row, Col, Table, Icon, Button } from 'antd'
import { companies } from '@services/api'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class CompaniesList extends Component<any> {
    handleEditCompany = async id => {
        const company = await companies.getCompany({ id })
        this.props.popupStore.togglePopup('editCompany', company.data)
    }

    render() {
        const { list, loading } = this.props
        const columns = [
            {
                title: 'קישור לרשימת הפוליסות',
                key: 'policy_list',
                width: 300,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => this.props.history.push(`/insurance/${record.id}`)}>
                        <Icon type="unordered-list" /> רשימת פוליסות
                    </Button>
                )
            },
            {
                title: 'שם החברה',
                key: 'name',
                width: 400,
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'שם הר ביטוח',
                key: 'long_name',
                align: 'right',
                render: (_, record) => <span>{record.long_name}</span>
            },
            {
                title: 'מזהה חברה',
                key: 'id',
                width: 200,
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'עריכת חברה',
                key: 'edit',
                width: 100,
                render: (_, record) => (
                    <Button onClick={() => this.handleEditCompany(record.id)}>
                        <Icon type="edit" />
                    </Button>
                )
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            rowClassName={() => style.user_row}
                            dataSource={list}
                            pagination={{
                                pageSize: 10
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(CompaniesList)
